import { initializeApp } from 'firebase/app';
import {
  getAuth,
  signInWithPopup,
  GoogleAuthProvider,
  signInWithEmailAndPassword,
} from 'firebase/auth';
import { initializeFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = initializeFirestore(app, {
  experimentalAutoDetectLongPolling: true,
});

export const isDevEnv = import.meta.env.VITE_FIREBASE_ENV === 'dev';

if (isDevEnv) {
  console.log(`🔧 Firebase DEV environment (${firebaseConfig.projectId})`);
}

const googleProvider = new GoogleAuthProvider();

export const signInWithOkta = () => signInWithPopup(auth, googleProvider);
export const devSignIn = (email, password = 'password123') =>
  signInWithEmailAndPassword(auth, email, password);
